import SupportSessionTimeoutModal from "@/components/app/SupportSessionTimeoutModal";
import { APP_PATHS } from "@/constants";
import { setupSupportSessionTimeoutNotifier } from "@/utils/supportSessionTimeoutError";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";

export function SupportSessionTimeoutRegistry() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleReturnToSupportAdmin = useCallback(() => {
    setOpen(false);
    navigate(`/${APP_PATHS.SUPPORT_ADMIN}`);
  }, [navigate]);

  useEffect(() => {
    return setupSupportSessionTimeoutNotifier(() => {
      setOpen(true);
    });
  }, []);

  return (
    <SupportSessionTimeoutModal
      open={open}
      onReturnToSupportAdmin={handleReturnToSupportAdmin}
    />
  );
}
